import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInstagram, faLinkedin} from "@fortawesome/free-brands-svg-icons";
import {faEnvelope} from "@fortawesome/free-regular-svg-icons";

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="footer-text">
                    <h3>Cody MACEDO</h3>
                    <p><a href="mailto:macedo.cody@gmail.com">macedo.cody@gmail.com</a></p>
                </div>
                <div className="social-network">
                    <a href="https://www.instagram.com/kydo.7/" target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram}/></a>
                    <a href="https://www.linkedin.com/in/cody-macedo-dev/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedin}/></a>
                    <a href="mailto:macedo.cody@gmail.com" aria-label="Email"><FontAwesomeIcon icon={faEnvelope}/></a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
